import type { LoomExplicitTrimPreview } from "./loomExplicitTrimPreview";
import type { LoomProvisionalUnionPreview } from "./loomProvisionalUnionPreview";
import type { LoomOwnedDisplaySurface } from "./loomViewportPresentation";

type AvailableExplicitTrim = Extract<LoomExplicitTrimPreview, { kind: "available" }>;
type AvailableProvisional = Extract<LoomProvisionalUnionPreview, { kind: "available" }>;

export function selectLoomRetainedSurface(
  accepted: LoomOwnedDisplaySurface | null,
  phase: "transient" | "dirty" | undefined,
  explicit: AvailableExplicitTrim | null,
  provisional: AvailableProvisional | null,
): { accepted: boolean; surface: LoomOwnedDisplaySurface | null } {
  if (accepted && phase !== "transient") return { accepted: true, surface: accepted };
  if (explicit) return { accepted: false, surface: {
    faceEntityIds: explicit.faceEntityIds, faces: explicit.faces,
    geometrySource: "retained-display-faces", positions: explicit.positions,
  } };
  if (provisional) return { accepted: false, surface: {
    faceEntityIds: Array.from(provisional.faceOperandIndices, (operand) => (
      provisional.sourceOperandIds[operand] ?? ""
    )),
    faces: provisional.faces, geometrySource: "retained-display-faces",
    positions: provisional.positions,
  } };
  return { accepted: false, surface: null };
}
